import {FaqItemBlock} from "@/lib/interfaces/blocks";
import { addNoopenerToBlankLinks } from "@/lib/helpers/html";
import { sanitiseHtml } from "@/lib/helpers/sanitise";

type FaqItemType = {
    block: FaqItemBlock
}
export default function FaqItem({block}: FaqItemType) {
    return (
        <details className="faq-section">
            <summary className="section-title">{block.content.question}</summary>
            <div className="section-content" dangerouslySetInnerHTML={{__html: sanitiseHtml(addNoopenerToBlankLinks(block.content.answer))}}></div>
        </details>
    )
}